<template>
  <div v-title data-title="物流信息">
    <div class="weui-loadmore weui-loadmore_line">
      <span class="weui-loadmore__tips">商品被拆成了{{formset.LogisticsCount}}个包裹</span>
    </div>

    <div
      class="weui-form-preview"
      @click="viewLogistics(model.ID)"
      v-for=" (model,$index) in formset.LogisticsList"
      :key="$index"
    >
      <div class="weui-form-preview__bd">
        <div class="weui-form-preview__item">
          <label class="weui-form-preview__label" style="color:#f97334;font-size:20px;">
            <img
              src="../../assets/img/notify.png"
              width="30"
              style="vertical-align: text-top;font-weight: bolder;"
            />
            {{formset.OrderState|filterdictbyid(14)}}
          </label>
          <span
            class="weui-form-preview__value"
            style="padding-top: 5px;"
          >{{model.LogisticsName|filterdictbyid(69)}}：{{model.LogisticsOrderNumber}}</span>
        </div>
        <div class="weui-form-preview__item">
          <label class="weui-form-preview__label" style="color:#303030">包裹正在快马加鞭赶来!</label>
        </div>
        <div class="weui-form-preview__item">
          <label class="weui-form-preview__label">订单编号：</label>
          <span class="weui-form-preview__value">{{formset.OrderNumber}}</span>
        </div>
        <div class="weui-form-preview__item">
          <label class="weui-form-preview__label">付款时间：</label>
          <span class="weui-form-preview__value">{{formset.PayTime}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";

export default {
  name: "logisticlist",
  data: function() {
    return {
      LoginType: -1,
      formset: { LogisticsList: [] },
      orderguid: ""
    };
  },
  created: function() {
    var url = window.location.href;
    this.orderguid = this.$route.query.orderguid;
    this.getlogisticsList();
  },
  methods: {
    getlogisticsList: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tblogistics/getlist", {
          params: { orderGuid: this.orderguid }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    viewLogistics: function(id) {
      this.$router.push({
        path: "/page/viewlogistics",
        query: {
          orderguid: this.orderguid,
          logisticsID: id
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/order/logisticlist.vue